import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import SplitterProps from './SplitterProps'
import KendoSplitterPane from './KendoSplitterPane'

export default {
    props: SplitterProps,
    emits: {
        'kendowidgetready': null
    },
    mixins: [
        KendoBaseComponent
    ],
    mounted() {
        this._resolveChildren()

        kendo.jQuery(this.$el).kendoSplitter(this.widgetOptions)
        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoSplitter()
        },
        _resolveChildren() {
            this.resolveChildren('panes', KendoSplitterPane.name)
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoSplitter/KendoSplitterMixin.js